import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { readConsent } from "@/lib/consent";

const URL_TRACK = `${process.env.REACT_APP_BACKEND_URL}/api/track`;
// Referrer of the page that opened the site, kept in memory only for this tab (no cookie or storage) to attribute orders to a source.
// A tracked link (?utm_source=instagram&utm_campaign=createur-awa) takes precedence over the referrer.
const utm = () => {
  if (typeof window === "undefined") return "";
  const q = new URLSearchParams(window.location.search);
  const s = q.get("utm_source");
  return s ? `utm:${s}|${q.get("utm_campaign") || ""}` : "";
};
const LANDING_REF = typeof document !== "undefined" ? utm() || document.referrer || "" : "";
// With analytics consent only: the last outside source (ad, TikTok, email…) is remembered 30 days, so a buyer who comes back later
// by typing the address is still attributed to what brought her.
const SRC_KEY = "ozy_src";
const SRC_AGE = 1000 * 60 * 60 * 24 * 30;
const external = (r) => Boolean(r) && (r.startsWith("utm:") || !r.includes(window.location.host));
export const landingRef = () => {
  if (!readConsent()?.analytics) return LANDING_REF;
  try {
    if (external(LANDING_REF)) {
      localStorage.setItem(SRC_KEY, JSON.stringify({ ref: LANDING_REF, at: Date.now() }));
      return LANDING_REF;
    }
    const s = JSON.parse(localStorage.getItem(SRC_KEY) || "null");
    return s && Date.now() - s.at < SRC_AGE ? s.ref : LANDING_REF;
  } catch {
    return LANDING_REF;
  }
};

/** Cookie-free page-view counter (no identifier stored in the browser). Skips automated browsers. */
export function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!process.env.REACT_APP_BACKEND_URL || navigator.webdriver) return;
    let tz = "";
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { tz = ""; }
    const body = JSON.stringify({ path: pathname, ref: LANDING_REF, tz });
    fetch(URL_TRACK, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  }, [pathname]);
  return null;
}

/** Étape de l'entonnoir (ajout au panier, page de commande) : même mesure sans cookie que les visites. */
export function trackStep(step) {
  if (!process.env.REACT_APP_BACKEND_URL || typeof navigator === "undefined" || navigator.webdriver) return;
  fetch(`${URL_TRACK}/step`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ step }), keepalive: true }).catch(() => {});
}